import {
  LICENSE_STATUS_RENEWAL_SUBMITTED,
  datasetTypes,
  onlinePlatforms,
} from '@/constants';
import { createGlobalStyle } from 'styled-components';
import './rsuite-theme-override.less';

/*
 * All our CSS variables should go here
 */

/**
 * ---------------- rentalscape color palette -------------------
 * Record of all colors used in the app, organized by color then from light to dark
 */
const colorPrimary = '#37A3BC';

const color1 = '#D6F1FF';
const color2 = '#34c3ff';
const color3 = '#40a9ff';
const color4 = '#2589f5';
// TODO: turn all the rgba's to hex where applicable.. there may be duplicates

const color5 = 'rgba(64, 169, 255, 0.6)';
const color6 = 'rgba(64, 169, 255, 0.7)';
const color7 = 'rgba(64, 169, 255, 0.8)';
const color8 = '#2098D1';
const color9 = '#689cc5';
const color10 = '#101938';
const color11 = 'rgba(16, 25, 56, 0.85)';
const color11b = 'rgba(16, 25, 56, 0.5)';
const color11c = 'rgba(16, 25, 56, 0.65)';
const color11d = 'rgba(16, 25, 56, 0.55)';
const color11e = 'rgb(16, 25, 56)';
const color11f = 'rgba(16, 25, 56, 0.4)';
const color12 = 'rgba(14, 26, 64, 0.45)';
const color13 = '#010733';
const color14 = '#020b2c';

const color15 = '#D6E4FF';
const color16 = '#d2ddfc';
const color17 = '#c7d1f3';
const color18 = '#c8d5fc';
const color19 = '#adc6ff';
const color19b = '#e6ecfe';
const color20 = 'rgba(89, 126, 247, 0.8)';
const color20b = 'rgba(89, 126, 247, 0.3)';

const color21 = '#93dbe9';
const color22 = 'rgba(54, 207, 201, 0.8)';
const color23 = '#36cfc9';
const color24 = '#00bfa5';

const color25 = '#9254de';
const color26 = 'rgba(146, 84, 222, 0.6)';
const color27 = 'rgba(255, 0, 255, 0.1)';

const color29 = '#ff47b4';

const color30 = '#F6FFC5';
const color31 = '#d3f261';
const color32 = '#bae637';
const color33 = '#a0d911';
const color34 = '#abd400';
const color35 = 'rgba(186, 230, 55, 0.7)';

const color36 = '#b7eb8f';
const color37 = '#8AB186';
const color38 = '#73d13d';
const color39 = 'rgba(149, 222, 100, 0.8)';
const color40 = 'rgba(54, 207, 201, 0.1)';

const color41 = '#fdb147';
const color42 = '#ff7a45';
const color43 = 'rgba(255, 122, 69, 0.8)';
const color43b = '#ff7875';

const color44 = '#fcffe6';
const color45 = '#fff2d9';
const color46 = '#FFE7BA';
const color47 = '#ffd666';
const color48 = '#ffc53d';
const color49 = 'rgba(255, 197, 61, 0.8)';
const color50 = '#fadb14';
const color51 = '#ffae12';

const color52 = '#5e6fa3';
const color53 = '#454c64';
const color54 = '#404760';
const color55 = '#3b4368';
const color56 = 'rgba(89, 126, 247, 0.1)';

const color57 = 'rgba(89, 126, 247, 0.03)';
const color58 = 'rgba(8, 10, 37, 0.03)';
const color59 = 'rgba(8, 10, 37, 0.05)';
const color60 = '#fof5ff';
const color61 = 'rgba(54, 65, 110, 0.1)';
const color62 = 'rgba(16, 25, 56, 0.05)';
const color63 = '#d9d9d9';
const color63a = '#dee5fd';
const color64 = 'rgba(255, 255, 255, 0.5)';
const color64a = 'rgba(255, 255, 255, 0.85)';
const color65 = '#bdc3c7';
const color66 = 'rgba(224, 242, 241, 0.5)';
const color66a = 'rgba(159, 163, 175, 0.5)';
const color66b = 'rgba(221, 232, 255, 0.5)';
const color67 = '#9fa3af';
const color68 = 'rgba(184, 195, 212, 0.4)';
const color69 = 'rgba(171, 185, 205, 0.4)';
const color70 = '#7a8195';
const color71 = '#616161eb';
const color71b = '#575757';
const color71c = '#37A3BC19';
const color71d = '#10193866';
const color72 = '#333333';
const color72a = '#b8c3d44c';
const color73 = 'darkGrey';

const color74 = 'rgba(0, 0, 0, 0.09)';
const color75 = 'rgba(0, 0, 0, 0.15)';
const color76 = 'rgba(0, 0, 0, 0.2)';
const color77 = 'rgba(0, 0, 0, 0.25)';
const color78 = '#7F7F7F'; // same as rgba(0, 0, 0, 0.5)
const color78b = 'rgba(0, 0, 0, 0.54)';
const color79 = 'rgba(0, 0, 0, 0.85)';
const color80 = '#000000';

const color81 = '#f2faff';
const color82 = '#ffffff';
const color83 = '#eaedf4';
const color84 = '#f9fbff';
const color85 = '#f2f2f5';
const color86 = '#f9f0ff';
const color87 = '#fbfcff';
const color88 = '#e6e6e9';
const color89 = '#fafbfe';
const color90 = '#e5e5ea';
const color91 = '#f1f5ff';
const color92 = '#e6f7ff';
const color93 = '#f6f9ff';
const color94 = '#f7f7fa';

export const color_airbnb = '#EA4B60';
const color_airbnb_t = 'rgba(234, 75, 96, 0.6)';
const color_airbnb_lgt = '#E5A5B0';

export const color_vrbo = '#3257B1';
const color_vrbo_t = 'rgba(50, 87, 177, 0.6)';
const color_vrbo_lgt = '#95ACDC';

export const color_flipkey = '#BE773A';
const color_flipkey_t = 'rgba(190, 119, 58, 0.6)';
const color_flipkey_lgt = '#DFBB9D';

export const color_others = '#A4C954';

const colorTransparent = 'transparent';

// ---------------- color groups -------------------

// Colors used for the charts
const chartColors = {
  currentStrPropertiesAccent: colorPrimary,
  bookingsAccent: color23,
  revenueAccent: color25,
  avgDailyRateAccent: color47,
  lostTotAccent: color5,
  registrationRateAccent: color34,
};

// Colors used for the inactive charts
const inactiveChartColors = {
  accentColor: color77,
  lightColor: color62,
};

// Colors used for calendars
const calendarColors = {
  normal: color19,
  light: color19b,
  blocked: color77,
  transparent: colorTransparent,
};

// Colors used for platforms
const platformColors = {
  airbnb: {
    accent: color_airbnb,
    dark: color_airbnb_t,
    light: color_airbnb_lgt,
  },
  vrbo: {
    accent: color_vrbo,
    dark: color_vrbo_t,
    light: color_vrbo_lgt,
  },
  booking: {
    accent: color33,
    dark: color35,
    light: color30,
  },
  homeaway: {
    accent: color3,
    dark: color6,
    light: color1,
  },
  flipkey: {
    accent: color_flipkey,
    dark: color_flipkey_t,
    light: color_flipkey_lgt,
  },
  other: {
    accent: color50,
    dark: color49,
  },
  others: {
    accent: color_others,
    dark: color_others,
  },
};

// Colors used for transient occupancy tax chart
const totColors = {
  accent: color24,
  secondary: color41,
};

// Colors used for active owners chart
const activeOwnersColors = {
  owner1: colorPrimary,
  owner2: color32,
  owner3: color48,
  owner4: color23,
  owner5: color43b,
};

// Colors used for the rental structure types
const rentalStructureColors = {
  mainStructureAccent: color25,
  aduAccent: color42,
  multifamilyAccent: color23,
  unknownAccent: color48,
};

// Colors used for the residiential type
const residentialTypeColor = {
  primaryAccent: color3,
  secondaryInvestmentAccent: color42,
  unknownAccent: color48,
};

// Colors used for the rental type
const unitTypeColors = {
  selfContainedAccent: colorPrimary,
  partialAccent: color32,
  unknownAccent: color48,
};

const rentalTypeColors = unitTypeColors;

// Colors used for the rental size chart
const rentalSizeColors = {
  oneBedAccent: color3,
  twoBedAccent: color42,
  threeBedAccent: color23,
  fourBedAcccent: color38,
};

// Colors used for the navigation bar
const navbarColors = {
  accent: colorPrimary,
  light: color20b,
  lighter: color66b,
  dark: color78,
};

// Colors used for pop ups
const popUpColors = {
  accent: color82,
  dark: color11,
};

// Colors used for text
const textColors = {
  dark1: color72,
  dark2: color79,
  dark3: color10,
  neutral: color71b,
  light1: color78b,
  light2: color62,
  light3: color78,
  accent: colorPrimary,
};

// Colors used for the map sidebar
const mapSidebarColors = {
  dark1: color11,
  accent: color82,
  light: color11b,
};

// Colors used on the map
const mapColors = {
  color1: color37,
  color2: color25,
  color3: colorPrimary,
  color4: color80,
};

const loginColors = {
  policyBackground: color11d,
  bannerText: color64a,
};

// Colors used for the help side panel
const helpNavColors = {
  border: color90,
  bg1: color93,
  bg2: color82,
  bg3: color11c,
};

// Color used on the help pages
const helpPageColors = {
  white: color82,
  borderGrey: color90,
  textColor: color10,
};

// ---------------- chart colors -------------------
const residentialTypeColors = {
  primary: '#40a9ff', // TODO: use variables for repeated colors
  secondaryInvestment: '#ff7a45',
  unknown: '#ffc53d',
};

// TODO: to remove, will be using the color groupings to access colors for charts
const activeStateColors = {
  [datasetTypes.CURRENT_STR_PROPERTIES]: {
    color: chartColors.currentStrPropertiesAccent,
    backgroundColor: 'rgba(89, 126, 247, 0.1)',
  },
  [datasetTypes.OCCUPANCY]: {
    color: chartColors.bookingsAccent,
    backgroundColor: 'rgba(54, 207, 201, 0.1)',
  },
  [datasetTypes.REVENUE]: {
    color: chartColors.revenueAccent,
    backgroundColor: 'rgba(255, 0, 255, 0.1)',
  },
};

const subtypeColors = {
  unitType: {
    selfContained: color7,
    room: color32,
    unknown: color48,
  },
  rentalType: {
    // TODO: FIXME: Remove this once data is correct
    selfContained: color7,
    room: color32,
    unknown: color48,
  },
  residentialType: {
    primary: color3,
    secondaryInvestment: color42,
    unknown: color48,
  },
  onlinePlatforms: {
    airbnb: color_airbnb,
    vrbo: color_vrbo,
    booking: color33,
    other: color50,
    homeaway: color3,
  },
  rentalStructure: {
    mainStructure: color25,
    adu: color42,
    multiFamily: color23,
    unknown: color48,
    other: color36,
  },
  rentalSize: {
    '1br': color3,
    '2br': color42,
    '3br': color23,
    '4br+': color38,
  },
  bookedRatio: {
    booked: '',
    blocked: '',
  },
};

const statusColors = {
  new: { fg: colorPrimary, bg: '#f0f5ff', border: '#d6e4ff' },
  updated: {
    fg: '#9254de',
    bg: 'rgba(146, 84, 222, 0.05)',
    border: 'rgba(146, 84, 222, 0.1)',
  },
  revoked: { fg: '#ad1457', bg: 'rgba(252, 228, 236, 0.5)', border: '#fce4ec' },
  withdrawn: {
    fg: '#795548',
    bg: 'rgba(239, 235, 233, 0.5)',
    border: '#efebe9',
  },
  current: { fg: colorPrimary, bg: '#f0f5ff', border: '#d6e4ff' },
  suspended: { fg: '#595959', bg: '#f5f5f5', border: '#e8e8e8' },
  submitted: {
    fg: '#08979c',
    bg: 'rgba(224, 242, 241, 0.25)',
    border: '#e0f2f1',
  },
  [LICENSE_STATUS_RENEWAL_SUBMITTED]: {
    fg: '#08979c',
    bg: 'rgba(224, 242, 241, 0.25)',
    border: '#e0f2f1',
  },
  reviewed: {
    fg: '#9254de',
    bg: 'rgba(146, 84, 222, 0.05)',
    border: 'rgba(146, 84, 222, 0.1)',
  },
  expired: { fg: '#ff4d4f', bg: 'rgba(255, 77, 79, 0.05)', border: '#fff1f0' },
  returned: {
    fg: '#fa8c16',
    bg: 'rgba(255, 169, 64, 0.05)',
    border: 'rgba(250, 140, 22, 0.1)',
  },
  waitlist: { fg: '#7CAFC4', bg: '#F2F7FA', border: '#F2F7FA' },

  // TODO: Ask Bing for these colors below
  created: { fg: colorPrimary, bg: '#f0f5ff', border: '#d6e4ff' },
  denied: { fg: '#ff4d4f', bg: 'rgba(255, 77, 79, 0.05)', border: '#fff1f0' },
  closed: { fg: '#ff4d4f', bg: 'rgba(255, 77, 79, 0.05)', border: '#fff1f0' },
};

const extraStatusColors = [
  { fg: '#73B8EE', bg: '#DDEEFB' },
  { fg: '#5C82E0', bg: '#CFDAF6' },
  { fg: '#B28AE9', bg: '#EBE1F9' },
  { fg: '#D183A3', bg: '#F1DAE3' },
  { fg: '#D89F8A', bg: '#F4E4DD' },
];

const color = {
  rentalscapeBlue: colorPrimary,
  occupancy: '#36cfc9',
  buttonDisabled: 'darkGrey', // TODO: check about this color with Bing
  [onlinePlatforms.AIRBNB]: color_airbnb,
  [onlinePlatforms.VRBO]: color_vrbo, // TODO: use variable
  [onlinePlatforms.BOOKING]: '#a0d911',
  [onlinePlatforms.FLIP_KEY]: color_flipkey,
  [onlinePlatforms.HOME_AWAY]: '#40A9FF',
  [onlinePlatforms.OTHERS]: color_others,
  chart: chartColors,
  residentialType: residentialTypeColors,
  rentalStructure: rentalStructureColors,
  rentalType: rentalTypeColors, // TODO: Remove when rentalType completely renamed to unit Type
  unitType: unitTypeColors,
  subtype: subtypeColors,
  activeStateColor: activeStateColors,
  inactiveStateColor: inactiveChartColors,
  calendarColor: calendarColors,
  platformColor: platformColors,
  helpPageColor: helpPageColors,
  statusColors,
  extraStatusColors,
  deleteColor: color43b,
};

const width = {
  verticalNavActiveMarker: '8px',
  verticalNav: '80px',
};

const sidebarWidth = '350px';

// ---------------- margins -------------------
const dashboardMarginTop = '26px';
const mapContainerMarginTop = '26px';
const propertyListContainerMarginTop = '26px';
const cardLgMarginLR = '45px';
const verticalNavItemMarginBottom = '24px';

// ---------------- paddings -------------------
const chartSmPaddingLeft = -10; // this is consumed as an INT by chartjs
const chartSmPaddingBottom = -10; // this is consumed as an INT by chartjs
const chartSmPaddingTop = 30;
const rsModalPaddingLR = '38px';
const cardPad = '32px';

// ---------------- heights -------------------
const standardCardHeight = '400px';

// ------------ common or other spacing -------
const dashCardGap = '20px';

const propertyHistoryColors = {
  monthTitleBg: color72,
  monthTitleFg: color82,
  monthSummaryBg: 'rgb(238, 243.5, 255)', // color66b,
  unbookableColor: colorTransparent,
  availableColor: colorTransparent, // 21,30
  swimlaneLabelPaneBg: '#fafafa', //'rgb(115.15, 115.25, 116.6)', // '#fafafa',
  monthContentSeparatorColor: '#fafafa',
  reviewerAvatarPlaceholderBg: color68,
  reviewerAvatarPlaceholderFg: 'white',
  platformColors: {
    airbnb: color_airbnb_lgt,
    vrbo: color_vrbo_lgt,
    flipkey: color_flipkey_lgt,
    homeaway: color41,
  },
  unknownPlatformColor: color35,
};

export const cssVars = {
  color,
  chartColors, // TODO: remove when implementing Object Oriented chart coloring
  propertyHistoryColors,
  width,
  sidebarWidth,
  textColors,
  helpNavColors,
  loginColors,
  // margins
  dashboardMarginTop,
  mapContainerMarginTop,
  propertyListContainerMarginTop,
  cardLgMarginLR,
  verticalNavItemMarginBottom,
  chartSmPaddingLeft,
  chartSmPaddingBottom,
  chartSmPaddingTop,
  rsModalPaddingLR,
  cardPad,
  // heights
  standardCardHeight,
  // other
  dashCardGap,
};

/*
 * All global css rules should go here
 */
export const GlobalStyles = createGlobalStyle`
  .mapboxgl-control-container .mapboxgl-ctrl-group button {
    width: 32px;
    height: 32px;
    margin-left: 0;
  }

  html {
    overflow-y: hidden;
    height: 100vh;

    @media print {
      overflow-y: visible !important;
      height: 100%;
    }
  }

  html, body, #root {
    font-family: Nunito Sans !important;
    font-size: 14px;
  }

  body, #root {
    height: 100%;
  }

  .rs-alert-item-content {
    box-shadow: unset !important;
  }

  .rs-btn-blue {
    background-color: ${cssVars.color.rentalscapeBlue} !important;
  }

  .rs-btn-primary {
    background-color: #37A3BC;
  }

  /* --------------- CSS Balloon Popup ---------------- */
  .action-menu-balloon-tooltip {
    ::before {
      display: none;
    }

    ::after {
      background-color: #454c64 !important;
      height: 28px;
      border-radius: 4px !important;
      top: 34px !important;
      font-size: 11px !important;
    }
  }

  /* --------------- CSS Universal Search ---------------- */
  .rs-drawer-open.rs-drawer-has-backdrop {
    padding-right: 0px;
  }

  .rs-drawer-full {
    width: 100% !important;
  }

  /* --------------- Filter Popover ---------------- */
  .filter-section-check-picker {
    /* this is +1 of the default zIndex for the Rsuite popover component. Rsuite's Popover is the
       parent of the CheckPicker that this class is trying to style */
    z-index: 1061;

    /* prevents long unwrappable content from expanding the popover beyond the width of the fixed-width container ,
    triggering the overflow behavior. */
    max-width: 100%;
  }

  .filter-section-check-picker .rs-check-item .rs-checkbox-checker > label {
    /* prevents from showing scrollbars when the label contains a long unwrappable word which does not fit.*/
    overflow: hidden;
    text-overflow: clip;
    white-space: normal;
  }

  /* --------------- PDF render when seeing historic scrapes ---------------- */
  .react-pdf__Document {
    padding: 0 50px !important;
  }

  .react-pdf__Page__canvas, .react-pdf__Page__textContent {
    width: 100% !important;
    height: auto !important;
  }

  .mapboxgl-popup {
    /* Default max-width is 240px, which is too small for what we need. */
    min-width: 250px;
    max-width: unset !important;

    .mapboxgl-popup-content {
      /* Default width is 308px, which is too small for what we need. */
      width: unset !important;
    }
  }
`;

export const fadeInAnimation = (duration = 1) => `
  animation-duration: ${duration}s;
  animation-fill-mode: both;
  animation-name: fadeIn;
  @keyframes fadeIn {
    from {
      opacity: 0.3;
    }
    to {
      opacity: 1;
    }
  }
`;
